<template lang="html">
  <el-dialog
    v-if="dialogVisible"
    title="流水投诉"
    width="500px"
    :visible="dialogVisible"
    :append-to-body="true"
    @close="close"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width=""
      class="add-goods-form"
    >
      <el-form-item label="" prop="content">
        <el-input
          type="textarea"
          v-model="ruleForm.content"
          placeholder="请输入投诉原因"
          ref="content"
          :rows="4"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit" :loading="btnLoading"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      ruleForm: {},
      rules: {},
      btnLoading: false
    };
  },
  computed: {},
  created() {},
  methods: {
    close() {
      this.$emit("update:dialogVisible", false);
    },
    async initData() {
      this.ruleForm = { content: this.content };
      this.rules = {
        content: [
          {
            required: true,
            message: "请输入投诉原因",
            trigger: ["blur", "change"]
          }
        ]
      };
      await this.$nextTick();
      this.$refs.content.focus();
    },
    submit() {
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) return false;
        try {
          this.btnLoading = true;
          await this.$http.get("/shipper/feedback/commit", {
            params: {
              content: this.ruleForm.content
            }
          });
          this.$message.success("投诉成功");
          this.close();
          this.$emit("close");
        } catch (e) {
        } finally {
          this.btnLoading = false;
        }
      });
    }
  },
  watch: {
    dialogVisible(newVal) {
      newVal && this.initData();
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/personal/flowingWater/components/flowingWaterTable/components/detailDialog/components/complaintDialog/index.vue